module.exports = __webpack_public_path__ + "img/star.e465d341.svg";